/**
 * 担当者機能 (#2642) で使用する文字列定数
 * 複数画面で利用されるラベル・文言を集約
 */
export const assigneeLabels = {
  /** フィールドラベル / 列ヘッダー / 結果画面の見出し */
  label: '担当者',
  /** ダイアログタイトル / 行メニュー文言 / 一括操作ボタン文言 */
  changeAction: '担当者変更',
  /** プルダウンのプレースホルダー */
  selectPlaceholder: '担当者を選択',
  /** 退会済ユーザーの表示文言 */
  withdrawnLabel: '退会済ユーザー',
  /** 担当者変更ダイアログの確定ボタン */
  confirmButton: '変更する',
  /** 担当者変更ダイアログの確定ボタン（処理中） */
  confirmButtonProcessing: '変更中...',
  /** 変更成功時のスナックバー */
  changeSuccess: '担当者を変更しました。',
  /** 変更失敗時のスナックバー */
  changeError: '担当者の変更に失敗しました',
  /** 一括変更ダイアログの対象表示 */
  bulkTargetCountText: (count: number): string => `${count}件のOCRデータ`,
} as const;
